var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 346",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#80c995",
    vectorEffect: "non-scaling-stroke",
    d: "m256 8.57-5.75-5.36"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9feab1",
    vectorEffect: "non-scaling-stroke",
    d: "M250.25 3.21 247.71.62q-.37-.37-.71.02c-5.86 6.61-10.56 14.35-14.92 20.73-6.03 8.83-20.92 12.59-31.78 14.06a.16.16 0 0 0-.02.31l5.54 1.69"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d49de6",
    vectorEffect: "non-scaling-stroke",
    d: "M205.82 37.43q-21.51 20.3-38.84 44.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffe98b",
    vectorEffect: "non-scaling-stroke",
    d: "M166.98 82.23q-1.59-13.52-4.21-26.28-1.32-6.45-3.79-12.22"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d7fafb",
    vectorEffect: "non-scaling-stroke",
    d: "M158.98 43.73c-4.28-8.21-9.54-11.76-17.69-15.33q-.49-.21-.5-.76l-.09-12.45"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f59db2",
    vectorEffect: "non-scaling-stroke",
    d: "m140.7 15.19 1.55.04q.65.02.67-.64L143.28 2q.02-.48-.46-.48l-5.64-.01"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fcb3bf",
    vectorEffect: "non-scaling-stroke",
    d: "m137.18 1.51-19.24-.31q-.6-.01-.6.58l-.12 12.17a.6.6 0 0 0 .45.59q1.54.4 2.47.18"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d7fafb",
    vectorEffect: "non-scaling-stroke",
    d: "M120.14 14.72q-1.04 5.67-.56 11.11.1 1.08-.96 1.3-14.69 3.02-21.58 16.37"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffe98b",
    vectorEffect: "non-scaling-stroke",
    d: "M97.04 43.5q-1.23.89-1.86 3.36"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9feab1",
    vectorEffect: "non-scaling-stroke",
    d: "m95.18 46.86-4.59-2.78"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#94e0a8",
    vectorEffect: "non-scaling-stroke",
    d: "M90.59 44.08q-2.52-.36-2.56-3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9feab1",
    vectorEffect: "non-scaling-stroke",
    d: "M88.03 41.08c.63-7.76-1.07-16.9-9.81-19.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#94e0a8",
    vectorEffect: "non-scaling-stroke",
    d: "M78.22 21.98q-2.26-.71-4.91.48"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80c995",
    vectorEffect: "non-scaling-stroke",
    d: "M73.31 22.46Q67.68 25.91 65.96 33a.44.43 21.5 0 1-.64.27c-8.82-5.11-16.58 2.94-15.43 12q.08.59-.51.55-7.04-.48-10.42 5.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#81bc8c",
    vectorEffect: "non-scaling-stroke",
    d: "m38.96 50.92-.57 1.48"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9feab1",
    vectorEffect: "non-scaling-stroke",
    d: "M38.39 52.4q-9.33-11.22-21.87-6.28"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#94e0a8",
    vectorEffect: "non-scaling-stroke",
    d: "M16.52 46.12c-7.19 5.23-7.96 13.29-4.56 20.92q.22.5-.32.61l-3.51.78"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8cd39c",
    vectorEffect: "non-scaling-stroke",
    d: "M8.13 68.43c-10.14 5.62-5.1 19.15 1.71 25.07a.58.57 50.2 0 1-.08.92c-2.75 1.66-5.42 4.03-6.41 7.13q-1.82 5.69 1.59 11.68"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f9dba7",
    vectorEffect: "non-scaling-stroke",
    d: "M4.94 113.23Q.29 142.24.54 172"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f8d097",
    vectorEffect: "non-scaling-stroke",
    d: "M.54 172c-.93 45.36 2.63 93.87 11.52 138.54 1.44 7.23 29.07 16.73 36.97 19.15q48.32 14.76 98.92 16.31"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#20b446",
    vectorEffect: "non-scaling-stroke",
    d: "m250.25 3.21-4.28 6.56"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2bbe4e",
    vectorEffect: "non-scaling-stroke",
    d: "M245.97 9.77q-5.57 7.04-9.8 14.92c-2.54 4.71-5.42 9.13-7.61 13.63q-3.09 6.37-6.53 11.3-.42.6-.49-.13l-.11-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5c7c7d",
    vectorEffect: "non-scaling-stroke",
    d: "m221.43 48.23.38-9.85q.02-.55-.53-.54l-6.03.12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#748798",
    vectorEffect: "non-scaling-stroke",
    d: "m215.25 37.96-9.43-.53"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f25172",
    vectorEffect: "non-scaling-stroke",
    d: "M137.18 1.51q-2.87 3.81-2.05 10.07c.17 1.3-.06 2.26-.36 3.47"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d4aebb",
    vectorEffect: "non-scaling-stroke",
    d: "m134.77 15.05-14.63-.33"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cd97ae",
    vectorEffect: "non-scaling-stroke",
    d: "m140.7 15.19-5.93-.14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80c995",
    vectorEffect: "non-scaling-stroke",
    d: "M256 8.8q-5.58 4.86-8.42 8.78c-7.95 10.98-5.4 26.01 1.58 37.05q.46.72-.37.53-.9-.21-2.09-1.24"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3e5b61",
    vectorEffect: "non-scaling-stroke",
    d: "m246.7 53.92-4.83-3.93"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d9d32",
    vectorEffect: "non-scaling-stroke",
    d: "M241.87 49.99q-6.49-18.03 2.7-34.7c1.07-1.95 1.23-3.42 1.4-5.52"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f8d097",
    vectorEffect: "non-scaling-stroke",
    d: "M153.93 346q39.24-1.44 75.01-17.35c2.02-.9 1.93-1.61 1.88-3.65q-.48-20.25-.92-40.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f7c694",
    vectorEffect: "non-scaling-stroke",
    d: "m229.9 284.5-4.17-173.26"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#bd91cb",
    vectorEffect: "non-scaling-stroke",
    d: "M225.73 111.24q2.5-7.11 3.77-9.99 8.84-20 15.55-40.82.99-3.07 1.65-6.51"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#496568",
    vectorEffect: "non-scaling-stroke",
    d: "m241.87 49.99-7.88-6.8q-.34-.29-.65.04L221.88 55.5a.52.52 0 0 1-.9-.38l.45-6.89"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d7e487",
    vectorEffect: "non-scaling-stroke",
    d: "M158.98 43.73q-15.3 3.06-26.05 3.18c-15.07.17-22.84-.03-35.89-3.41"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#34cb5a",
    vectorEffect: "non-scaling-stroke",
    d: "m78.22 21.98 9.81 19.1M90.59 44.08q2.4 6.92 5.86 12.61.25.4.69.23l1.4-.57"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#94ca34",
    vectorEffect: "non-scaling-stroke",
    d: "M98.54 56.35q-.91 1.91-.48 2.79.25.53.78.26 3.58-1.82 6.92-1.96"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#34cb5a",
    vectorEffect: "non-scaling-stroke",
    d: "M105.76 57.44q-.19 7.05 3.32 13.44"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#169d35",
    vectorEffect: "non-scaling-stroke",
    d: "m109.08 70.88-4.92 6.39q-.41.52-.55-.12l-1.63-7.05q-.12-.52-.64-.39l-2.6.62a.58.58 0 0 0-.43.68l2.18 10.73q.11.53-.2.97l-9.05 13.21"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#21b445",
    vectorEffect: "non-scaling-stroke",
    d: "M91.24 95.92q-2.02-9.59-2.96-18.65c-.22-2.03-2.17-6.66.75-8.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#169d35",
    vectorEffect: "non-scaling-stroke",
    d: "m89.03 68.98 4.61-6.03q.34-.44.89-.57 2.41-.58 2.62-3.04a.58.58 0 0 0-.88-.55c-2.17 1.3-6.75 5.15-8.9 1.72a1.14 1.14 0 0 1-.13-.94q.89-2.99-1.7-4.11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#158b2a",
    vectorEffect: "non-scaling-stroke",
    d: "M85.54 55.46q0-.49.01-.99"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#21b445",
    vectorEffect: "non-scaling-stroke",
    d: "m85.55 54.47-5.43-17.18"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#15aa3e",
    vectorEffect: "non-scaling-stroke",
    d: "M80.12 37.29q-.65-1.16-1.37-4.04-1.3-5.24-5.44-10.79"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d9d32",
    vectorEffect: "non-scaling-stroke",
    d: "M80.12 37.29q-1.34-.31-1.8-3.52"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#017416",
    vectorEffect: "non-scaling-stroke",
    d: "m78.32 33.77-2.33-.26q-.67-.07-.87.58l-4.48 15.06a.7.7 0 0 1-1.29.13l-3.32-6.24q-.32-.61-.96-.33l-2.42 1.04q-.42.18-.2.59 2.5 4.79 5.13 9.35c1.1 1.92.47 2.93-.39 4.77"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#028622",
    vectorEffect: "non-scaling-stroke",
    d: "M67.19 58.46q-9.31-12.39-22.78-7.48-.45.17-.94.15l-4.51-.21"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d7e1e",
    vectorEffect: "non-scaling-stroke",
    d: "M78.32 33.77c.98 3.36-5.41 20.44-6.78 24.53a.63.63 0 0 0 .9.76q6.1-3.28 13.11-4.59"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#02670e",
    vectorEffect: "non-scaling-stroke",
    d: "m85.54 55.46.35 1.71a.92.92 0 0 1-.33.9q-.92.71-2.19.68-.49-.02-.94.19l-7.48 3.54"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d7e1e",
    vectorEffect: "non-scaling-stroke",
    d: "M74.95 62.48q-5.81 1.12-9.15 6.15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#209532",
    vectorEffect: "non-scaling-stroke",
    d: "m65.8 68.63-1.64-6.27"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#02670e",
    vectorEffect: "non-scaling-stroke",
    d: "M64.16 62.36q3.3-1.94 3.03-3.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#922fb2",
    vectorEffect: "non-scaling-stroke",
    d: "M215.25 37.96c1.29-.1 1.52.88.96 1.82q-3.77 6.31-6.15 13.25c-1.52 4.44-4.83 7.92-6.64 12.33q-9.82 23.96-19.24 48.07-.42 1.09-2.15 1.03"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c02089",
    vectorEffect: "non-scaling-stroke",
    d: "M182.03 114.46q-2.56-11.16-11.53-18.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#617183",
    vectorEffect: "non-scaling-stroke",
    d: "m170.5 95.96 5.94-3.93a.49.48 22.9 0 0-.36-.88l-10.4 1.92"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c02089",
    vectorEffect: "non-scaling-stroke",
    d: "m165.68 93.07-3.92-2.27"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d48772",
    vectorEffect: "non-scaling-stroke",
    d: "m161.76 90.8 5.22-8.57"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b45860",
    vectorEffect: "non-scaling-stroke",
    d: "m225.73 111.24-43.3 10.14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a8146e",
    vectorEffect: "non-scaling-stroke",
    d: "M182.43 121.38q.95-3.06-.4-6.92"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#eb6c2d",
    vectorEffect: "non-scaling-stroke",
    d: "m161.76 90.8-11.88-2.82"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8cbd28",
    vectorEffect: "non-scaling-stroke",
    d: "m149.88 87.98-1.53-5.79a.62.62 0 0 0-1.18-.07l-2.36 6.09"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f5873d",
    vectorEffect: "non-scaling-stroke",
    d: "M144.81 88.21q-5.91.07-11.32 2.14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#94ca34",
    vectorEffect: "non-scaling-stroke",
    d: "m133.49 90.35-9.02-4.54"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9fd43c",
    vectorEffect: "non-scaling-stroke",
    d: "M124.47 85.81q-.51-.16-.98-.69-.33-.37-.16-.85c5.01-13.58-2.04-26.57-17.57-26.83M98.54 56.35q-.2-4.97-3.36-9.49"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#20a63e",
    vectorEffect: "non-scaling-stroke",
    d: "m38.39 52.4 1.59 2.37q.68 1 1.73.41c8.8-4.92 18.21-2.01 22.45 7.18"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2bbe4e",
    vectorEffect: "non-scaling-stroke",
    d: "M65.8 68.63c-.23 2.56 3.37 2.55 4.77 3.11q12.59 4.98 12.93 18.68"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#20a63e",
    vectorEffect: "non-scaling-stroke",
    d: "m83.5 90.42-1.74 7.34"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2bbe4e",
    vectorEffect: "non-scaling-stroke",
    d: "M81.76 97.76q-6.43 13.76-20.01 20.69-2.75 1.4-5.65 3.09"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#99c659",
    vectorEffect: "non-scaling-stroke",
    d: "m56.1 121.54-6.02-.53"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#20a63e",
    vectorEffect: "non-scaling-stroke",
    d: "m50.08 121.01-4.97-15.34q-.42-1.27.53-2.21l11.6-11.45q.36-.35.02-.73l-2.02-2.22q-.32-.36-.66-.02L43.96 99.66a.39.39 0 0 1-.65-.15l-6.74-19.66a.88.87 58.9 0 1 .22-.9q4.3-4.2 8.68-8.32.47-.45.2-1.03-.61-1.33-1.94-2.05-.57-.3-1.02.15l-7.38 7.33q-.49.49-.75-.16-4.99-12.71-10.43-25.23-.22-.5-.77-.53-1.49-.06-2.9 1.01"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#34cb5a",
    vectorEffect: "non-scaling-stroke",
    d: "M20.48 50.12q-2.42-1.03-3.96-4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#169d35",
    vectorEffect: "non-scaling-stroke",
    d: "m20.48 50.12 3.58 8.55a.47.47 0 0 1-.6.62l-6.02-2.18q-.48-.18-.78.23c-3.25 4.45 6.29 5.72 8.79 6.44a1.65 1.63 86.9 0 1 1.08.98l8.01 20.41a.46.45 86.2 0 1-.53.61l-10.76-2.61a1.24 1.23-80.5 0 0-1.52 1.09q-.23 2.68 2.32 2.96 2.81.3 11.62 2.98.44.13.58.57l6.04 18.42q.16.47-.34.39l-15.51-2.54"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#21b445",
    vectorEffect: "non-scaling-stroke",
    d: "m26.44 107.04-8.37-19.1a.48.48 0 0 0-.82-.09c-.82 1.07-8.62 8.69-8.04 2.13q.04-.38.35-.59c2.99-2.09.71-4.28.46-6.7a1.54 1.54 0 0 1 2.98-.66q.23.67.77 1.18a1.31 1.31 0 0 0 2.15-1.35q-.79-2.49-2.41-4.48-.29-.35-.72-.23-1.91.53-3.01 2.28a1.18 1.18 0 0 1-1.79.25q-1.4-1.27-.9-3.05.18-.66.82-.9l3.52-1.31a.51.5-19 0 0 .3-.61q-.97-3.14-3.6-5.38"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7b9834",
    vectorEffect: "non-scaling-stroke",
    d: "m50.08 121.01-4.49-.52"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#169d35",
    vectorEffect: "non-scaling-stroke",
    d: "m45.59 120.49-1.6-5.66a1.39 1.39 0 0 0-1.12-1l-12.62-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d9029",
    vectorEffect: "non-scaling-stroke",
    d: "m30.25 111.79-4.9-1.11q-.77-.17-.81-.95-.14-2.79 1.9-2.69M89.03 68.98q-5.92-6.6-14.08-6.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#34cb5a",
    vectorEffect: "non-scaling-stroke",
    d: "M124.47 85.81q-1.52 1.37-2.19 3.24-.16.44.17.79l3.54 3.68"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9c9e71",
    vectorEffect: "non-scaling-stroke",
    d: "M125.99 93.52q-6.63 4.25-11.63 10.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#34cb5a",
    vectorEffect: "non-scaling-stroke",
    d: "M114.36 103.56c-.89-2.55-.44-5.06-.97-7.39-1.09-4.86-.67-9.77-2.41-14.61a1.06 1.04-42.7 0 1 .04-.81l.8-1.73q.22-.48-.26-.72-1.18-.58-1.6-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#20a63e",
    vectorEffect: "non-scaling-stroke",
    d: "m109.96 76.5 4.67-5.82a.62.61 37.1 0 0-.13-.88l-2.24-1.61q-.46-.32-.83.09l-2.35 2.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#34cb5a",
    vectorEffect: "non-scaling-stroke",
    d: "m119.12 83.38-4.21-1.88q-.4-.18-.68.17l-.19.23a.47.46 29.9 0 0 .2.73q1.74.65 2.4 2.32.22.56.82.57 1.47.04 2-1.31a.65.64 23.3 0 0-.34-.83"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d9029",
    vectorEffect: "non-scaling-stroke",
    d: "m91.24 95.92-2.97 4.32a.46.46 0 0 1-.8-.08l-3.97-9.74"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#169d35",
    vectorEffect: "non-scaling-stroke",
    d: "M109.96 76.5 95.75 96.68q-.34.47.25.49l10.78.36q.61.02.7.62.26 1.65-.62 2.92-.28.4-.75.4-5.97.04-11.79-1.14-.51-.1-.92.23-1.14.91-1.72 2.46"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d9029",
    vectorEffect: "non-scaling-stroke",
    d: "m91.68 103.02-12.49 20.36"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#798d24",
    vectorEffect: "non-scaling-stroke",
    d: "m79.19 123.38-4.57-.23"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d9029",
    vectorEffect: "non-scaling-stroke",
    d: "m74.62 123.15 10.28-17.16a1.06 1.06 0 0 0 .06-.97l-3.2-7.26"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#21b445",
    vectorEffect: "non-scaling-stroke",
    d: "m30.25 111.79.65 6.66"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#86af44",
    vectorEffect: "non-scaling-stroke",
    d: "M30.9 118.45q-13.5-1.6-25.96-5.22"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#919468",
    vectorEffect: "non-scaling-stroke",
    d: "M114.36 103.56c-4.79 6.87-7.43 12.86-7.66 21.06"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8db140",
    vectorEffect: "non-scaling-stroke",
    d: "m106.7 124.62-11.08-.28"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#21b445",
    vectorEffect: "non-scaling-stroke",
    d: "M95.62 124.34c-.96-4.18-3.72-14.19-2.02-17.9q.2-.45-.08-.84l-1.84-2.58"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#77563f",
    vectorEffect: "non-scaling-stroke",
    d: "m149.88 87.98 1.92 7.23q.14.56.71.45l13.17-2.59M170.5 95.96l-15.16 9.33a.55.55 0 0 0-.09.86l16.96 16.59"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#839a31",
    vectorEffect: "non-scaling-stroke",
    d: "M172.21 122.74q-1.57.69-2.95.48"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#77563f",
    vectorEffect: "non-scaling-stroke",
    d: "m169.26 123.22-.23-.38q-.14-.23-.38-.34l-18.63-9.05q-.58-.28-.73.35l-2.58 10.72"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#84a434",
    vectorEffect: "non-scaling-stroke",
    d: "M146.71 124.52q-.96.07-1.65-.17"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#21b445",
    vectorEffect: "non-scaling-stroke",
    d: "M145.06 124.35q-1.16-.31-1.52-1.17-.18-.41.11-.75c.59-.69-.69-9.02-.58-10.79.41-6.36.41-9.98.44-15.08q0-.5-.28-.9l-.8-1.14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#81714f",
    vectorEffect: "non-scaling-stroke",
    d: "m142.43 94.52 2.38-6.31"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8a7e5b",
    vectorEffect: "non-scaling-stroke",
    d: "m133.49 90.35 8.34 4.32q.18.09.36-.01l.24-.14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8db140",
    vectorEffect: "non-scaling-stroke",
    d: "m145.06 124.35-5.66.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80634b",
    vectorEffect: "non-scaling-stroke",
    d: "m139.4 124.6-2.81-12.55a.7.69 77.8 0 0-.82-.53l-6.02 1.27"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8a7e5b",
    vectorEffect: "non-scaling-stroke",
    d: "m129.75 112.79-7.94 1.76"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#919468",
    vectorEffect: "non-scaling-stroke",
    d: "m121.81 114.55-12.22 2.67a.35.35 0 0 1-.26-.63l23.76-15.31q.54-.34.08-.79l-7.18-6.97"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f25172",
    vectorEffect: "non-scaling-stroke",
    d: "M121.81 114.55q-.84 5.23-3.37 10.15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f58457",
    vectorEffect: "non-scaling-stroke",
    d: "m118.44 124.7-11.74-.08"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e24937",
    vectorEffect: "non-scaling-stroke",
    d: "m182.43 121.38-10.22 1.36"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#84a434",
    vectorEffect: "non-scaling-stroke",
    d: "m74.62 123.15-8.87-.61"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#86af44",
    vectorEffect: "non-scaling-stroke",
    d: "m65.75 122.54-9.65-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#84a434",
    vectorEffect: "non-scaling-stroke",
    d: "m95.62 124.34-16.43-.96"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ef972c",
    vectorEffect: "non-scaling-stroke",
    d: "m229.9 284.5-.17 1.4q-.07.64-.7.51-3.03-.63-5-2.96-.3-.36-.73-.52-2.67-1.03-1.9-3.81.13-.47-.12-.89c-1.39-2.31-2.4-9.08-6.02-7.56a.74.74 0 0 1-.94-1.05l1.34-2.36a1.05 1.04-71.5 0 0-.77-1.55c-4.31-.55-12.2-1.24-15.33 2.21-2.85 3.14-1.25 6.04-1.48 9.41-.23 3.48-.03 7.75 2.42 10.06q.38.35.4.86.51 9.1.81 18.16a1.25 1.25 0 0 1-1.95 1.08q-.67-.45-1.44-.26-.25.06-.25.07-.08.24-.09.25a.71.69 57.3 0 1-1.35-.32q.83-10.37-3.4-19.94a1.03 1.01-5.8 0 0-.71-.57q-4.8-1.01-6.31-5.75-.16-.51-.64-.74-1.13-.53-1.84.63a1.4 1.4 0 0 0 .99 2.11c2.71.4.7 3.73-.57 4.76q-.39.32-.45.81-.5 3.52-2.14 6.71a1.03 1.03 0 0 0 .02.97l1.8 3.29q.24.45.07.93c-1.35 3.66-4.65 2.18-6.92.49-4.13-3.09-4.19 5.5-4.36 7.7-.45 5.55-7.33 10.67-11.93 12.84q-.24.11-.24-.16v-.29q-.01-.46-.48-.48-1.78-.07-3.38-.92a1.21 1.18-35.6 0 0-.79-.12q-1.25.22-2.21-.54-.35-.28-.14-.67l1.55-2.94q.29-.55-.3-.78c-2.71-1.06-2.32-2.81-2.26-5.28q.51-20.49.86-40.97.49-29.02 1.77-40.25c1.42-12.43 2.19-26.32 3.48-37.33 1.09-9.29 2.47-18.16 2.91-27.71.68-14.67 4.47-25.92 3.17-39.41"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e24937",
    vectorEffect: "non-scaling-stroke",
    d: "m164.18 123.62 5.08-.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ef972c",
    vectorEffect: "non-scaling-stroke",
    d: "M176.2 183.95c.72-4.02-3.9-3.66-6.35-2.83a1.2 1.2 0 0 0 .19 2.32l5.6.91q.48.08.56-.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e35339",
    vectorEffect: "non-scaling-stroke",
    d: "m139.4 124.6-10.2.45"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e02054",
    vectorEffect: "non-scaling-stroke",
    d: "m129.2 125.05.55-12.26"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8ebc50",
    vectorEffect: "non-scaling-stroke",
    d: "m45.59 120.49-14.69-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ed6e49",
    vectorEffect: "non-scaling-stroke",
    d: "m129.2 125.05-10.76-.35"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f2ac3f",
    vectorEffect: "non-scaling-stroke",
    d: "M65.75 122.54c-2.46 6.25-6.83 13.76-8.89 17.89-9.58 19.19-19.98 38.25-28.02 58.14q-.18.46-.67.42-1.49-.09-2.63-.96-.36-.28-.82-.28h-3.65q-.72 0-.93-.69l-.81-2.65q-.2-.66-.89-.66h-.82q-.38 0-.46.37-.66 3.02-2.7 5.32a.57.57 0 0 1-.89-.03q-1.35-1.78-1.48-4.09-.03-.57-.6-.65l-6.01-.8a.51.51 0 0 1-.38-.76c.69-1.21 1.23-2.32 1.32-3.8.27-4.1 3.67-20.97-5.88-17.31"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e35339",
    vectorEffect: "non-scaling-stroke",
    d: "m164.18 123.62-17.47.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f7c88a",
    vectorEffect: "non-scaling-stroke",
    d: "m18.77 263.99 1.72 19.88a1.59 1.58 8.3 0 0 1.01 1.35c32.74 12.64 72.09 16.11 106.83 14.25a.98.97 88.2 0 0 .92-.99l-.3-32.71"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f7cd91",
    vectorEffect: "non-scaling-stroke",
    d: "m128.95 265.77-.18-48.85q0-.48-.48-.46c-35.72 1.66-72.31 2.31-107.84-2.14a.34.33-82.1 0 0-.37.29q-3.37 24.63-1.31 49.38"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fef4ed",
    vectorEffect: "non-scaling-stroke",
    d: "M128.95 265.77q-1.99.5-3.25 2.13-.31.4-.78.53l-3.71 1.07a1.17 1.16-35.4 0 1-.98-.16c-4.19-2.81-12.3 1.15-15.57 4.02-3.48 3.06-13.67 4.79-18.38 6.03-3.09.81-6.17.77-9.32.86-4.11.11-7.47 1.59-12.05-.88q-.45-.25-.65-.73c-1.43-3.55-1.77-7.13-3.47-10.57a1.85 1.85 0 0 0-2.48-.84l-18.48 9.09q-.55.27-.82-.28c-1.99-3.86-6-10.65-10.53-11.77-2.26-.57-6.76-1.46-8.77.28q-.09.08-.12-.03-.09-.3-.23-.59-.12-.23-.33-.1l-.26.16"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h256v8.57l-5.75-5.36-2.54-2.59q-.37-.37-.71.02c-5.86 6.61-10.56 14.35-14.92 20.73-6.03 8.83-20.92 12.59-31.78 14.06a.16.16 0 0 0-.02.31l5.54 1.69q-21.51 20.3-38.84 44.8-1.59-13.52-4.21-26.28-1.32-6.45-3.79-12.22c-4.28-8.21-9.54-11.76-17.69-15.33q-.49-.21-.5-.76l-.09-12.45 1.55.04q.65.02.67-.64L143.28 2q.02-.48-.46-.48l-5.64-.01-19.24-.31q-.6-.01-.6.58l-.12 12.17a.6.6 0 0 0 .45.59q1.54.4 2.47.18-1.04 5.67-.56 11.11.1 1.08-.96 1.3-14.69 3.02-21.58 16.37-1.23.89-1.86 3.36l-4.59-2.78q-2.52-.36-2.56-3c.63-7.76-1.07-16.9-9.81-19.1q-2.26-.71-4.91.48-5.63 3.45-7.35 10.54a.44.43 21.5 0 1-.64.27c-8.82-5.11-16.58 2.94-15.43 12q.08.59-.51.55-7.04-.48-10.42 5.1l-.57 1.48q-9.33-11.22-21.87-6.28c-7.19 5.23-7.96 13.29-4.56 20.92q.22.5-.32.61l-3.51.78c-10.14 5.62-5.1 19.15 1.71 25.07a.58.57 50.2 0 1-.08.92c-2.75 1.66-5.42 4.03-6.41 7.13q-1.82 5.69 1.59 11.68Q.29 142.24.54 172c-.93 45.36 2.63 93.87 11.52 138.54 1.44 7.23 29.07 16.73 36.97 19.15q48.32 14.76 98.92 16.31H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3ed462",
    d: "m250.25 3.21-4.28 6.56q-5.57 7.04-9.8 14.92c-2.54 4.71-5.42 9.13-7.61 13.63q-3.09 6.37-6.53 11.3-.42.6-.49-.13l-.11-1.26.38-9.85q.02-.55-.53-.54l-6.03.12-9.43-.53-5.54-1.69a.16.16 0 0 1 .02-.31c10.86-1.47 25.75-5.23 31.78-14.06 4.36-6.38 9.06-14.12 14.92-20.73q.34-.39.71-.02l2.54 2.59z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9677f",
    d: "M137.18 1.51q-2.87 3.81-2.05 10.07c.17 1.3-.06 2.26-.36 3.47l-14.63-.33q-.93.22-2.47-.18a.6.6 0 0 1-.45-.59l.12-12.17q0-.59.6-.58l19.24.31z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea3a64",
    d: "m137.18 1.51 5.64.01q.48 0 .46.48l-.36 12.59q-.02.66-.67.64l-1.55-.04-5.93-.14c.3-1.21.53-2.17.36-3.47q-.82-6.26 2.05-10.07z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#01932a",
    d: "M250.25 3.21 256 8.57v.23q-5.58 4.86-8.42 8.78c-7.95 10.98-5.4 26.01 1.58 37.05q.46.72-.37.53-.9-.21-2.09-1.24l-4.83-3.93q-6.49-18.03 2.7-34.7c1.07-1.95 1.23-3.42 1.4-5.52l4.28-6.56z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M256 8.8V346H153.93q39.24-1.44 75.01-17.35c2.02-.9 1.93-1.61 1.88-3.65q-.48-20.25-.92-40.5l-4.17-173.26q2.5-7.11 3.77-9.99 8.84-20 15.55-40.82.99-3.07 1.65-6.51 1.19 1.03 2.09 1.24.83.19.37-.53c-6.98-11.04-9.53-26.07-1.58-37.05q2.84-3.92 8.42-8.78z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#18a739",
    d: "M245.97 9.77c-.17 2.1-.33 3.57-1.4 5.52q-9.19 16.67-2.7 34.7l-7.88-6.8q-.34-.29-.65.04L221.88 55.5a.52.52 0 0 1-.9-.38l.45-6.89.11 1.26q.07.73.49.13 3.44-4.93 6.53-11.3c2.19-4.5 5.07-8.92 7.61-13.63q4.23-7.88 9.8-14.92z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#aff4f7",
    d: "m120.14 14.72 14.63.33 5.93.14.09 12.45q.01.55.5.76c8.15 3.57 13.41 7.12 17.69 15.33q-15.3 3.06-26.05 3.18c-15.07.17-22.84-.03-35.89-3.41q6.89-13.35 21.58-16.37 1.06-.22.96-1.3-.48-5.44.56-11.11z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#29c151",
    d: "m78.22 21.98 9.81 19.1q.04 2.64 2.56 3 2.4 6.92 5.86 12.61.25.4.69.23l1.4-.57q-.91 1.91-.48 2.79.25.53.78.26 3.58-1.82 6.92-1.96-.19 7.05 3.32 13.44l-4.92 6.39q-.41.52-.55-.12l-1.63-7.05q-.12-.52-.64-.39l-2.6.62a.58.58 0 0 0-.43.68l2.18 10.73q.11.53-.2.97l-9.05 13.21q-2.02-9.59-2.96-18.65c-.22-2.03-2.17-6.66.75-8.29l4.61-6.03q.34-.44.89-.57 2.41-.58 2.62-3.04a.58.58 0 0 0-.88-.55c-2.17 1.3-6.75 5.15-8.9 1.72a1.14 1.14 0 0 1-.13-.94q.89-2.99-1.7-4.11 0-.49.01-.99l-5.43-17.18q-.65-1.16-1.37-4.04-1.3-5.24-5.44-10.79 2.65-1.19 4.91-.48z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#3ed462",
    d: "M78.22 21.98c8.74 2.2 10.44 11.34 9.81 19.1l-9.81-19.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#01932a",
    d: "M73.31 22.46q4.14 5.55 5.44 10.79.72 2.88 1.37 4.04-1.34-.31-1.8-3.52l-2.33-.26q-.67-.07-.87.58l-4.48 15.06a.7.7 0 0 1-1.29.13l-3.32-6.24q-.32-.61-.96-.33l-2.42 1.04q-.42.18-.2.59 2.5 4.79 5.13 9.35c1.1 1.92.47 2.93-.39 4.77q-9.31-12.39-22.78-7.48-.45.17-.94.15l-4.51-.21q3.38-5.58 10.42-5.1.59.04.51-.55c-1.15-9.06 6.61-17.11 15.43-12a.44.43 21.5 0 0 .64-.27q1.72-7.09 7.35-10.54z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#015502",
    d: "M78.32 33.77c.98 3.36-5.41 20.44-6.78 24.53a.63.63 0 0 0 .9.76q6.1-3.28 13.11-4.59-.01.5-.01.99l.35 1.71a.92.92 0 0 1-.33.9q-.92.71-2.19.68-.49-.02-.94.19l-7.48 3.54q-5.81 1.12-9.15 6.15l-1.64-6.27q3.3-1.94 3.03-3.9c.86-1.84 1.49-2.85.39-4.77q-2.63-4.56-5.13-9.35-.22-.41.2-.59l2.42-1.04q.64-.28.96.33l3.32 6.24a.7.7 0 0 0 1.29-.13l4.48-15.06q.2-.65.87-.58l2.33.26z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#18a739",
    d: "M78.32 33.77q.46 3.21 1.8 3.52l5.43 17.18q-7.01 1.31-13.11 4.59a.63.63 0 0 1-.9-.76c1.37-4.09 7.76-21.17 6.78-24.53z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#a93acd",
    d: "m205.82 37.43 9.43.53c1.29-.1 1.52.88.96 1.82q-3.77 6.31-6.15 13.25c-1.52 4.44-4.83 7.92-6.64 12.33q-9.82 23.96-19.24 48.07-.42 1.09-2.15 1.03-2.56-11.16-11.53-18.5l5.94-3.93a.49.48 22.9 0 0-.36-.88l-10.4 1.92-3.92-2.27 5.22-8.57q17.33-24.5 38.84-44.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#7a2397",
    d: "m221.43 48.23-.45 6.89a.52.52 0 0 0 .9.38l11.46-12.27q.31-.33.65-.04l7.88 6.8 4.83 3.93q-.66 3.44-1.65 6.51-6.71 20.82-15.55 40.82-1.27 2.88-3.77 9.99l-43.3 10.14q.95-3.06-.4-6.92 1.73.06 2.15-1.03 9.42-24.11 19.24-48.07c1.81-4.41 5.12-7.89 6.64-12.33q2.38-6.94 6.15-13.25c.56-.94.33-1.92-.96-1.82l6.03-.12q.55-.01.53.54l-.38 9.85z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd316",
    d: "M97.04 43.5c13.05 3.38 20.82 3.58 35.89 3.41q10.75-.12 26.05-3.18 2.47 5.77 3.79 12.22 2.62 12.76 4.21 26.28l-5.22 8.57-11.88-2.82-1.53-5.79a.62.62 0 0 0-1.18-.07l-2.36 6.09q-5.91.07-11.32 2.14l-9.02-4.54q-.51-.16-.98-.69-.33-.37-.16-.85c5.01-13.58-2.04-26.57-17.57-26.83q-3.34.14-6.92 1.96-.53.27-.78-.26-.43-.88.48-2.79-.2-4.97-3.36-9.49.63-2.47 1.86-3.36z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#3ed462",
    d: "m90.59 44.08 4.59 2.78q3.16 4.52 3.36 9.49l-1.4.57q-.44.17-.69-.23-3.46-5.69-5.86-12.61zM38.39 52.4l1.59 2.37q.68 1 1.73.41c8.8-4.92 18.21-2.01 22.45 7.18l1.64 6.27c-.23 2.56 3.37 2.55 4.77 3.11q12.59 4.98 12.93 18.68l-1.74 7.34q-6.43 13.76-20.01 20.69-2.75 1.4-5.65 3.09l-6.02-.53-4.97-15.34q-.42-1.27.53-2.21l11.6-11.45q.36-.35.02-.73l-2.02-2.22q-.32-.36-.66-.02L43.96 99.66a.39.39 0 0 1-.65-.15l-6.74-19.66a.88.87 58.9 0 1 .22-.9q4.3-4.2 8.68-8.32.47-.45.2-1.03-.61-1.33-1.94-2.05-.57-.3-1.02.15l-7.38 7.33q-.49.49-.75-.16-4.99-12.71-10.43-25.23-.22-.5-.77-.53-1.49-.06-2.9 1.01-2.42-1.03-3.96-4 12.54-4.94 21.87 6.28z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#29c151",
    d: "M16.52 46.12q1.54 2.97 3.96 4l3.58 8.55a.47.47 0 0 1-.6.62l-6.02-2.18q-.48-.18-.78.23c-3.25 4.45 6.29 5.72 8.79 6.44a1.65 1.63 86.9 0 1 1.08.98l8.01 20.41a.46.45 86.2 0 1-.53.61l-10.76-2.61a1.24 1.23-80.5 0 0-1.52 1.09q-.23 2.68 2.32 2.96 2.81.3 11.62 2.98.44.13.58.57l6.04 18.42q.16.47-.34.39l-15.51-2.54-8.37-19.1a.48.48 0 0 0-.82-.09c-.82 1.07-8.62 8.69-8.04 2.13q.04-.38.35-.59c2.99-2.09.71-4.28.46-6.7a1.54 1.54 0 0 1 2.98-.66q.23.67.77 1.18a1.31 1.31 0 0 0 2.15-1.35q-.79-2.49-2.41-4.48-.29-.35-.72-.23-1.91.53-3.01 2.28a1.18 1.18 0 0 1-1.79.25q-1.4-1.27-.9-3.05.18-.66.82-.9l3.52-1.31a.51.5-19 0 0 .3-.61q-.97-3.14-3.6-5.38l3.51-.78q.54-.11.32-.61c-3.4-7.63-2.63-15.69 4.56-20.92z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#027819",
    d: "m50.08 121.01-4.49-.52-1.6-5.66a1.39 1.39 0 0 0-1.12-1l-12.62-2.04-4.9-1.11q-.77-.17-.81-.95-.14-2.79 1.9-2.69l15.51 2.54q.5.08.34-.39l-6.04-18.42q-.14-.44-.58-.57-8.81-2.68-11.62-2.98-2.55-.28-2.32-2.96a1.24 1.23-80.5 0 1 1.52-1.09l10.76 2.61a.46.45 86.2 0 0 .53-.61l-8.01-20.41a1.65 1.63 86.9 0 0-1.08-.98c-2.5-.72-12.04-1.99-8.79-6.44q.3-.41.78-.23l6.02 2.18a.47.47 0 0 0 .6-.62l-3.58-8.55q1.41-1.07 2.9-1.01.55.03.77.53 5.44 12.52 10.43 25.23.26.65.75.16l7.38-7.33q.45-.45 1.02-.15 1.33.72 1.94 2.05.27.58-.2 1.03-4.38 4.12-8.68 8.32a.88.87 58.9 0 0-.22.9l6.74 19.66a.39.39 0 0 0 .65.15l10.62-10.62q.34-.34.66.02l2.02 2.22q.34.38-.02.73l-11.6 11.45q-.95.94-.53 2.21l4.97 15.34zM67.19 58.46q.27 1.96-3.03 3.9c-4.24-9.19-13.65-12.1-22.45-7.18q-1.05.59-1.73-.41l-1.59-2.37.57-1.48 4.51.21q.49.02.94-.15 13.47-4.91 22.78 7.48zM85.54 55.46q2.59 1.12 1.7 4.11a1.14 1.14 0 0 0 .13.94c2.15 3.43 6.73-.42 8.9-1.72a.58.58 0 0 1 .88.55q-.21 2.46-2.62 3.04-.55.13-.89.57l-4.61 6.03q-5.92-6.6-14.08-6.5l7.48-3.54q.45-.21.94-.19 1.27.03 2.19-.68a.92.92 0 0 0 .33-.9l-.35-1.71z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#3ed462",
    d: "M105.76 57.44c15.53.26 22.58 13.25 17.57 26.83q-.17.48.16.85.47.53.98.69-1.52 1.37-2.19 3.24-.16.44.17.79l3.54 3.68q-6.63 4.25-11.63 10.04c-.89-2.55-.44-5.06-.97-7.39-1.09-4.86-.67-9.77-2.41-14.61a1.06 1.04-42.7 0 1 .04-.81l.8-1.73q.22-.48-.26-.72-1.18-.58-1.6-1.8l4.67-5.82a.62.61 37.1 0 0-.13-.88l-2.24-1.61q-.46-.32-.83.09l-2.35 2.6q-3.51-6.39-3.32-13.44zm13.36 25.94-4.21-1.88q-.4-.18-.68.17l-.19.23a.47.46 29.9 0 0 .2.73q1.74.65 2.4 2.32.22.56.82.57 1.47.04 2-1.31a.65.64 23.3 0 0-.34-.83z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#18a739",
    d: "M74.95 62.48q8.16-.1 14.08 6.5c-2.92 1.63-.97 6.26-.75 8.29q.94 9.06 2.96 18.65l-2.97 4.32a.46.46 0 0 1-.8-.08l-3.97-9.74q-.34-13.7-12.93-18.68c-1.4-.56-5-.55-4.77-3.11q3.34-5.03 9.15-6.15z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#027819",
    d: "M109.96 76.5 95.75 96.68q-.34.47.25.49l10.78.36q.61.02.7.62.26 1.65-.62 2.92-.28.4-.75.4-5.97.04-11.79-1.14-.51-.1-.92.23-1.14.91-1.72 2.46l-12.49 20.36-4.57-.23 10.28-17.16a1.06 1.06 0 0 0 .06-.97l-3.2-7.26 1.74-7.34 3.97 9.74a.46.46 0 0 0 .8.08l2.97-4.32 9.05-13.21q.31-.44.2-.97l-2.18-10.73a.58.58 0 0 1 .43-.68l2.6-.62q.52-.13.64.39l1.63 7.05q.14.64.55.12l4.92-6.39 2.35-2.6q.37-.41.83-.09l2.24 1.61a.62.61 37.1 0 1 .13.88l-4.67 5.82z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#18a739",
    d: "M8.13 68.43q2.63 2.24 3.6 5.38a.51.5-19 0 1-.3.61l-3.52 1.31q-.64.24-.82.9-.5 1.78.9 3.05a1.18 1.18 0 0 0 1.79-.25q1.1-1.75 3.01-2.28.43-.12.72.23 1.62 1.99 2.41 4.48a1.31 1.31 0 0 1-2.15 1.35q-.54-.51-.77-1.18a1.54 1.54 0 0 0-2.98.66c.25 2.42 2.53 4.61-.46 6.7q-.31.21-.35.59c-.58 6.56 7.22-1.06 8.04-2.13a.48.48 0 0 1 .82.09l8.37 19.1q-2.04-.1-1.9 2.69.04.78.81.95l4.9 1.11.65 6.66q-13.5-1.6-25.96-5.22-3.41-5.99-1.59-11.68c.99-3.1 3.66-5.47 6.41-7.13a.58.57 50.2 0 0 .08-.92C3.03 87.58-2.01 74.05 8.13 68.43z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#29c151",
    d: "M109.96 76.5q.42 1.22 1.6 1.8.48.24.26.72l-.8 1.73a1.06 1.04-42.7 0 0-.04.81c1.74 4.84 1.32 9.75 2.41 14.61.53 2.33.08 4.84.97 7.39-4.79 6.87-7.43 12.86-7.66 21.06l-11.08-.28c-.96-4.18-3.72-14.19-2.02-17.9q.2-.45-.08-.84l-1.84-2.58q.58-1.55 1.72-2.46.41-.33.92-.23 5.82 1.18 11.79 1.14.47 0 .75-.4.88-1.27.62-2.92-.09-.6-.7-.62L96 97.17q-.59-.02-.25-.49l14.21-20.18zM119.12 83.38a.65.64 23.3 0 1 .34.83q-.53 1.35-2 1.31-.6-.01-.82-.57-.66-1.67-2.4-2.32a.47.46 29.9 0 1-.2-.73l.19-.23q.28-.35.68-.17l4.21 1.88z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#18a739",
    d: "m149.88 87.98 1.92 7.23q.14.56.71.45l13.17-2.59 10.4-1.92a.49.48 22.9 0 1 .36.88l-5.94 3.93-15.16 9.33a.55.55 0 0 0-.09.86l16.96 16.59q-1.57.69-2.95.48l-.23-.38q-.14-.23-.38-.34l-18.63-9.05q-.58-.28-.73.35l-2.58 10.72q-.96.07-1.65-.17-1.16-.31-1.52-1.17-.18-.41.11-.75c.59-.69-.69-9.02-.58-10.79.41-6.36.41-9.98.44-15.08q0-.5-.28-.9l-.8-1.14 2.38-6.31 2.36-6.09a.62.62 0 0 1 1.18.07l1.53 5.79z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#29c151",
    d: "m124.47 85.81 9.02 4.54 8.34 4.32q.18.09.36-.01l.24-.14.8 1.14q.28.4.28.9c-.03 5.1-.03 8.72-.44 15.08-.11 1.77 1.17 10.1.58 10.79q-.29.34-.11.75.36.86 1.52 1.17l-5.66.25-2.81-12.55a.7.69 77.8 0 0-.82-.53l-6.02 1.27-7.94 1.76-12.22 2.67a.35.35 0 0 1-.26-.63l23.76-15.31q.54-.34.08-.79l-7.18-6.97-3.54-3.68q-.33-.35-.17-.79.67-1.87 2.19-3.24z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#d60544",
    d: "m149.88 87.98 11.88 2.82 3.92 2.27-13.17 2.59q-.57.11-.71-.45l-1.92-7.23z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea3a64",
    d: "m144.81 88.21-2.38 6.31-.24.14q-.18.1-.36.01l-8.34-4.32q5.41-2.07 11.32-2.14z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9677f",
    d: "m125.99 93.52 7.18 6.97q.46.45-.08.79l-23.76 15.31a.35.35 0 0 0 .26.63l12.22-2.67q-.84 5.23-3.37 10.15l-11.74-.08c.23-8.2 2.87-14.19 7.66-21.06q5-5.79 11.63-10.04z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#d60544",
    d: "M170.5 95.96q8.97 7.34 11.53 18.5 1.35 3.86.4 6.92l-10.22 1.36-16.96-16.59a.55.55 0 0 1 .09-.86l15.16-9.33z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#18a739",
    d: "m81.76 97.76 3.2 7.26a1.06 1.06 0 0 1-.06.97l-10.28 17.16-8.87-.61-9.65-1q2.9-1.69 5.65-3.09 13.58-6.93 20.01-20.69zM91.68 103.02l1.84 2.58q.28.39.08.84c-1.7 3.71 1.06 13.72 2.02 17.9l-16.43-.96 12.49-20.36z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#ee8d29",
    d: "m225.73 111.24 4.17 173.26-.17 1.4q-.07.64-.7.51-3.03-.63-5-2.96-.3-.36-.73-.52-2.67-1.03-1.9-3.81.13-.47-.12-.89c-1.39-2.31-2.4-9.08-6.02-7.56a.74.74 0 0 1-.94-1.05l1.34-2.36a1.05 1.04-71.5 0 0-.77-1.55c-4.31-.55-12.2-1.24-15.33 2.21-2.85 3.14-1.25 6.04-1.48 9.41-.23 3.48-.03 7.75 2.42 10.06q.38.35.4.86.51 9.1.81 18.16a1.25 1.25 0 0 1-1.95 1.08q-.67-.45-1.44-.26-.25.06-.25.07-.08.24-.09.25a.71.69 57.3 0 1-1.35-.32q.83-10.37-3.4-19.94a1.03 1.01-5.8 0 0-.71-.57q-4.8-1.01-6.31-5.75-.16-.51-.64-.74-1.13-.53-1.84.63a1.4 1.4 0 0 0 .99 2.11c2.71.4.7 3.73-.57 4.76q-.39.32-.45.81-.5 3.52-2.14 6.71a1.03 1.03 0 0 0 .02.97l1.8 3.29q.24.45.07.93c-1.35 3.66-4.65 2.18-6.92.49-4.13-3.09-4.19 5.5-4.36 7.7-.45 5.55-7.33 10.67-11.93 12.84q-.24.11-.24-.16v-.29q-.01-.46-.48-.48-1.78-.07-3.38-.92a1.21 1.18-35.6 0 0-.79-.12q-1.25.22-2.21-.54-.35-.28-.14-.67l1.55-2.94q.29-.55-.3-.78c-2.71-1.06-2.32-2.81-2.26-5.28q.51-20.49.86-40.97.49-29.02 1.77-40.25c1.42-12.43 2.19-26.32 3.48-37.33 1.09-9.29 2.47-18.16 2.91-27.71.68-14.67 4.47-25.92 3.17-39.41l5.08-.4q1.38.21 2.95-.48l10.22-1.36 43.3-10.14zm-49.53 72.71c.72-4.02-3.9-3.66-6.35-2.83a1.2 1.2 0 0 0 .19 2.32l5.6.91q.48.08.56-.4z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#d60544",
    d: "m139.4 124.6-10.2.45.55-12.26 6.02-1.27a.7.69 77.8 0 1 .82.53l2.81 12.55z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#29c151",
    d: "m30.25 111.79 12.62 2.04a1.39 1.39 0 0 1 1.12 1l1.6 5.66-14.69-2.04-.65-6.66z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea3a64",
    d: "m129.75 112.79-.55 12.26-10.76-.35q2.53-4.92 3.37-10.15l7.94-1.76z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#f3b74f",
    d: "M4.94 113.23q12.46 3.62 25.96 5.22l14.69 2.04 4.49.52 6.02.53 9.65 1c-2.46 6.25-6.83 13.76-8.89 17.89-9.58 19.19-19.98 38.25-28.02 58.14q-.18.46-.67.42-1.49-.09-2.63-.96-.36-.28-.82-.28h-3.65q-.72 0-.93-.69l-.81-2.65q-.2-.66-.89-.66h-.82q-.38 0-.46.37-.66 3.02-2.7 5.32a.57.57 0 0 1-.89-.03q-1.35-1.78-1.48-4.09-.03-.57-.6-.65l-6.01-.8a.51.51 0 0 1-.38-.76c.69-1.21 1.23-2.32 1.32-3.8.27-4.1 3.67-20.97-5.88-17.31q-.25-29.76 4.4-58.77z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#d60544",
    d: "m169.26 123.22-5.08.4-17.47.9 2.58-10.72q.15-.63.73-.35l18.63 9.05q.24.11.38.34l.23.38z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0a12e",
    d: "m65.75 122.54 8.87.61 4.57.23 16.43.96 11.08.28 11.74.08 10.76.35 10.2-.45 5.66-.25q.69.24 1.65.17l17.47-.9c1.3 13.49-2.49 24.74-3.17 39.41-.44 9.55-1.82 18.42-2.91 27.71-1.29 11.01-2.06 24.9-3.48 37.33q-1.28 11.23-1.77 40.25-.35 20.48-.86 40.97c-.06 2.47-.45 4.22 2.26 5.28q.59.23.3.78l-1.55 2.94q-.21.39.14.67.96.76 2.21.54a1.21 1.18-35.6 0 1 .79.12q1.6.85 3.38.92.47.02.48.48v.29q0 .27.24.16c4.6-2.17 11.48-7.29 11.93-12.84.17-2.2.23-10.79 4.36-7.7 2.27 1.69 5.57 3.17 6.92-.49q.17-.48-.07-.93l-1.8-3.29a1.03 1.03 0 0 1-.02-.97q1.64-3.19 2.14-6.71.06-.49.45-.81c1.27-1.03 3.28-4.36.57-4.76a1.4 1.4 0 0 1-.99-2.11q.71-1.16 1.84-.63.48.23.64.74 1.51 4.74 6.31 5.75a1.03 1.01-5.8 0 1 .71.57q4.23 9.57 3.4 19.94a.71.69 57.3 0 0 1.35.32q.01-.01.09-.25 0-.01.25-.07.77-.19 1.44.26a1.25 1.25 0 0 0 1.95-1.08q-.3-9.06-.81-18.16-.02-.51-.4-.86c-2.45-2.31-2.65-6.58-2.42-10.06.23-3.37-1.37-6.27 1.48-9.41 3.13-3.45 11.02-2.76 15.33-2.21a1.05 1.04-71.5 0 1 .77 1.55l-1.34 2.36a.74.74 0 0 0 .94 1.05c3.62-1.52 4.63 5.25 6.02 7.56q.25.42.12.89-.77 2.78 1.9 3.81.43.16.73.52 1.97 2.33 5 2.96.63.13.7-.51l.17-1.4q.44 20.25.92 40.5c.05 2.04.14 2.75-1.88 3.65q-35.77 15.91-75.01 17.35h-5.98q-50.6-1.55-98.92-16.31c-7.9-2.42-35.53-11.92-36.97-19.15C3.17 265.87-.39 217.36.54 172c9.55-3.66 6.15 13.21 5.88 17.31-.09 1.48-.63 2.59-1.32 3.8a.51.51 0 0 0 .38.76l6.01.8q.57.08.6.65.13 2.31 1.48 4.09a.57.57 0 0 0 .89.03q2.04-2.3 2.7-5.32.08-.37.46-.37h.82q.69 0 .89.66l.81 2.65q.21.69.93.69h3.65q.46 0 .82.28 1.14.87 2.63.96.49.04.67-.42c8.04-19.89 18.44-38.95 28.02-58.14 2.06-4.13 6.43-11.64 8.89-17.89zM18.77 263.99l1.72 19.88a1.59 1.58 8.3 0 0 1.01 1.35c32.74 12.64 72.09 16.11 106.83 14.25a.98.97 88.2 0 0 .92-.99l-.3-32.71-.18-48.85q0-.48-.48-.46c-35.72 1.66-72.31 2.31-107.84-2.14a.34.33-82.1 0 0-.37.29q-3.37 24.63-1.31 49.38z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0a12e",
    d: "M169.85 181.12c2.45-.83 7.07-1.19 6.35 2.83q-.08.48-.56.4l-5.6-.91a1.2 1.2 0 0 1-.19-2.32z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f3",
    d: "M128.95 265.77q-1.99.5-3.25 2.13-.31.4-.78.53l-3.71 1.07a1.17 1.16-35.4 0 1-.98-.16c-4.19-2.81-12.3 1.15-15.57 4.02-3.48 3.06-13.67 4.79-18.38 6.03-3.09.81-6.17.77-9.32.86-4.11.11-7.47 1.59-12.05-.88q-.45-.25-.65-.73c-1.43-3.55-1.77-7.13-3.47-10.57a1.85 1.85 0 0 0-2.48-.84l-18.48 9.09q-.55.27-.82-.28c-1.99-3.86-6-10.65-10.53-11.77-2.26-.57-6.76-1.46-8.77.28q-.09.08-.12-.03-.09-.3-.23-.59-.12-.23-.33-.1l-.26.16q-2.06-24.75 1.31-49.38a.34.33-82.1 0 1 .37-.29c35.53 4.45 72.12 3.8 107.84 2.14q.48-.02.48.46l.18 48.85z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdefe6",
    d: "m128.95 265.77.3 32.71a.98.97 88.2 0 1-.92.99c-34.74 1.86-74.09-1.61-106.83-14.25a1.59 1.58 8.3 0 1-1.01-1.35l-1.72-19.88.26-.16q.21-.13.33.1.14.29.23.59.03.11.12.03c2.01-1.74 6.51-.85 8.77-.28 4.53 1.12 8.54 7.91 10.53 11.77q.27.55.82.28l18.48-9.09a1.85 1.85 0 0 1 2.48.84c1.7 3.44 2.04 7.02 3.47 10.57q.2.48.65.73c4.58 2.47 7.94.99 12.05.88 3.15-.09 6.23-.05 9.32-.86 4.71-1.24 14.9-2.97 18.38-6.03 3.27-2.87 11.38-6.83 15.57-4.02a1.17 1.16-35.4 0 0 .98.16l3.71-1.07q.47-.13.78-.53 1.26-1.63 3.25-2.13z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.b15602b56f8a98191b49e62645739e5e.svg";
export { ForwardRef as ReactComponent };